import React, { useEffect, useMemo, useState } from "react";
import "./Header.css";
import { FaPhoneAlt, FaBars, FaTimes } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { useLocalContext } from "../../context/LocalContext";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { webinfo = {} } = useLocalContext();

  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const phone = webinfo.phone || "+91 80000 00000";

  const navItems = useMemo(
    () => [
      { label: "Home", to: "/" },
      { label: "Solutions", to: "/services" },
      { label: "Strategy", to: "/our-strategies" },
      { label: "About", to: "/about" },
      { label: "Process", to: "/process" },
      { label: "Consult", to: "/contact" },
    ],
    []
  );

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isActive = (to) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header className={`hd4 ${scrolled ? "hd4--scrolled" : ""}`}>
      <div className="hd4-inner">
        <button className="hd4-logo" onClick={() => navigate("/")}>
          <img src={webinfo.logowhite || webinfo.logo} alt="Logo" />
        </button>

        <nav className="hd4-nav">
          {navItems.map((it) => (
            <button
              key={it.to}
              className={`hd4-link ${isActive(it.to) ? "is-active" : ""}`}
              onClick={() => navigate(it.to)}
            >
              {it.label}
            </button>
          ))}
        </nav>

        <div className="hd4-actions">
          <a className="hd4-call" href={`tel:${phone}`}>
            <FaPhoneAlt /> {phone}
          </a>
          <button className="hd4-cta" onClick={() => navigate("/contact")}>
            Book Consultation
          </button>
        </div>

        <button className="hd4-burger" onClick={() => setMenuOpen(true)}>
          <FaBars />
        </button>
      </div>

      {/* MOBILE */}
      <div className={`hd4-drawer ${menuOpen ? "is-open" : ""}`}>
        <button className="hd4-backdrop" onClick={() => setMenuOpen(false)} />
        <div className="hd4-panel">
          <button className="hd4-burger" onClick={() => setMenuOpen(false)}>
            <FaTimes />
          </button>

          <nav className="hd4-mnav">
            {navItems.map((it) => (
              <button
                key={it.to}
                className={`hd4-mitem ${isActive(it.to) ? "is-active" : ""}`}
                onClick={() => {
                  setMenuOpen(false);
                  navigate(it.to);
                }}
              >
                {it.label}
              </button>
            ))}
          </nav>

          <div className="hd4-mcta">
            <button
              className="hd4-mprimary"
              onClick={() => navigate("/contact")}
            >
              Book Consultation
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;